"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    dataSource: Object | Array,
    autoBind: Boolean,
    type: String,
    theme: String,
    valueField: String,
    colorField: String,
    textField: String,
    template: String | Function,
    colors: Array,

    // Events
    itemCreated: Function,
    dataBound: Function
};